export const SENTRY_DEV = 'http://e8f36b66bd34416c8f978263142236fe@167.179.105.193:9000/16';
export const SENTRY_PRODUCT = 'http://a66ef3fe3e2e484f9261380f432c503f@167.179.105.193:9000/9';
